import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Transition } from '@headlessui/react'

const MODAL_MESSAGE =
  'Upload a resume to unlock applications, tailored resumes, and better job matching.'

interface ResumeRequirementModalProps {
  open: boolean
  onClose: () => void
}

export const ResumeRequirementModal: React.FC<ResumeRequirementModalProps> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate()

  const handleUploadClick = () => {
    onClose()
    navigate('/resumes')
  }

  return (
    <Transition show={open} as={React.Fragment as React.ElementType}>
      <div className="fixed inset-0 z-[999] flex items-center justify-center">
        <div
          className="absolute inset-0 bg-slate-900/70 backdrop-blur-sm transition-opacity"
          onClick={onClose}
          onKeyDown={(e) => e.key === 'Escape' && onClose()}
          role="button"
          tabIndex={0}
          aria-label="Close"
        />
        <div className="relative w-full max-w-md mx-4 rounded-2xl bg-white shadow-xl overflow-hidden">
          <div className="px-6 py-5">
            <div className="flex items-start justify-between gap-4">
              <h2 className="text-xl font-semibold text-slate-900">
                Add your first resume
              </h2>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex h-8 w-8 items-center justify-center rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-700"
                aria-label="Close"
              >
                ×
              </button>
            </div>
            <p className="mt-3 text-slate-600">{MODAL_MESSAGE}</p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3">
              <button
                type="button"
                onClick={handleUploadClick}
                className="inline-flex justify-center items-center px-4 py-2.5 rounded-lg font-medium bg-indigo-600 text-white hover:bg-indigo-700"
              >
                Upload Resume
              </button>
              <button
                type="button"
                onClick={onClose}
                className="inline-flex justify-center items-center px-4 py-2.5 rounded-lg font-medium border border-slate-300 text-slate-700 hover:bg-slate-50"
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  )
}
